import moment from "moment-timezone";
import { LIMITES } from "./schema";
import { aInstante } from "./payload";

/* Reglas de la publicación, únicas para las tres pantallas. Antes cada una
 * tenía las suyas: el límite de la descripción no coincidía con la tarjeta y
 * la fecha de inicio nunca se validaba (comparaba un texto con una fecha). */

// margen para no rechazar un "desde" puesto para ahora mismo
const MARGEN_MINUTOS = 5;

export const validarPublicacion = (form, { esNueva = true, ahora = moment() } = {}) => {
  const errores = {};

  const titulo = form.titulo.trim();
  if (titulo.length < LIMITES.TITULO_MIN) {
    errores.titulo = `El título necesita al menos ${LIMITES.TITULO_MIN} caracteres.`;
  } else if (titulo.length > LIMITES.TITULO_MAX) {
    errores.titulo = `El título no puede superar ${LIMITES.TITULO_MAX} caracteres.`;
  }

  const descripcion = form.descripcion.trim();
  if (descripcion.length < LIMITES.DESCRIPCION_MIN) {
    errores.descripcion = `La descripción necesita al menos ${LIMITES.DESCRIPCION_MIN} caracteres.`;
  } else if (descripcion.length > LIMITES.DESCRIPCION_MAX) {
    errores.descripcion = `La descripción no puede superar ${LIMITES.DESCRIPCION_MAX} caracteres.`;
  }

  if (!form.media.length) {
    errores.media = "Subí al menos una imagen.";
  }

  if (!form.desde || !form.hasta) {
    errores.fechas = "Completá desde y hasta cuándo se muestra la publicación.";
  } else {
    const desde = aInstante(form.desde);
    const hasta = aInstante(form.hasta);
    if (!hasta.isAfter(desde)) {
      errores.fechas = "La fecha de fin tiene que ser posterior a la de inicio.";
    } else if (esNueva && desde.isBefore(ahora.clone().subtract(MARGEN_MINUTOS, "minutes"))) {
      // al editar se permite: una publicación activa ya empezó
      errores.fechas = "La publicación no puede empezar en el pasado.";
    }
  }

  return errores;
};

export const hayErrores = (errores) => Object.keys(errores || {}).length > 0;
